import createModel, { prop } from '../lib/create_model';
import LiveboardType from 'models/liveboards/liveboard_type';

export const ActiveSession = createModel({
  modelName: 'ActiveSession',
  properties: {
    conversationId: String,
    customerId: String,
    startedAt: String,
    sessionTypes: [String],
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export const UtilizationStats = createModel({
  modelName: 'UtilizationStats',
  properties: {
    agentId: String,
    status: String,
    statusUpdatedAt: String,
    presenceUpdatedAt: String,
    availableChannels: [String],
    onCall: Boolean,
    activity: String,
    reasonId: String,
    statusReasonId: String,
    activeSessions: [ActiveSession],
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default createModel({
  modelName: 'AgentsLiveboard',
  properties: {
    utilization: [UtilizationStats],
    timezone: prop(String).default('America/New_York'),
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: LiveboardType.AGENTS });
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/liveboards/agents_liveboard.js